import React from 'react';
import { Button, Form, Grid, Header, Image, Message, Segment } from 'semantic-ui-react';
//import { MDBBtn } from "mdbreact";
import auth0Client from '../Auth/Auth';

import escudo from './../../assets/img/escudo.png';
import './Login.css';

export default class Login extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      collapsed: true,
      logged :  true 
    };
  }

  async login(){
    if(await auth0Client.handleAuthentication() == 'acceso'){
      this.setState({
        isLoading: true
      })
    }
    await auth0Client.handleAuthentication();
  }

  componentDidMount() {
    console.log('Login - componentDidMount - INI');

    if(localStorage.getItem('AccessToken') != null || localStorage.getItem('expires_at') != null || localStorage.getItem('operaciones') != null || localStorage.getItem('nickname') != null){
      //window.location.href = '/inicio';  
      window.location.href = '/';
      console.log('Login - componentDidMount - LOGUEADO...ir a inicio');
    }else{
      console.log('Login - componentDidMount - REQUIERE LOGIN');
      this.login();
    }
  }

  loginWithRedirect = () => {
    console.log('Login - loginWithRedirect - INI');
    if (auth0Client.isAuthenticated()) {
        auth0Client.signIn();
    }
  }

  signOut = () => {
      console.log('Login - signOut - INI');

      auth0Client.signOut();
      this.props.history.replace('/');
  } 

  render(){

    return (

      <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450 }}>

        <Header as='h2' color='teal' textAlign='center'>
          <Image src={escudo} /> Log-in Sistema Experto
        </Header>
      
        <Form size='large' >
          <Segment stacked>

            <Button color='teal' fluid size='large' 
                    onClick={() => { this.loginWithRedirect() }} >
              Acceder
            </Button>

          </Segment>
        </Form>
      
      </Grid.Column>
    </Grid>

    )
  }

}
/*
import PropTypes from 'prop-types';
import * as constantes from '../../constantes';
const server = constantes.REST_API_PRIVATE;

async function loginUser(credentials) {
  
  let url = server + '/auth' ;

  return fetch( url , {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(credentials)
  }).then(data => data.json())
}

export default function Login({ setToken }) {
  
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [countIntentos, setCountIntentos] = useState( 0 );

  const handleSubmit = async e => {

    e.preventDefault();

    const token = await loginUser({
      username,
      password
    });

    setToken(token);
    console.log( 'Cantidad de intentos = ' + countIntentos );
    setCountIntentos( countIntentos + 1 );
  }
 
  return( 
    
    <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
      <Grid.Column style={{ maxWidth: 450 }}>

        <Header as='h2' color='teal' textAlign='center'>
          <Image src={escudo} /> Log-in Sistema Experto
        </Header>
      
        <Form size='large' onSubmit={handleSubmit}>
          <Segment stacked>

            <Form.Input fluid icon='user' iconPosition='left' 
                        onChange={e => setUserName(e.target.value)}
                        placeholder='Nombre de usuario' />

            <Form.Input fluid icon='lock' iconPosition='left' type='password'
                        onChange={e => setPassword(e.target.value)} 
                        placeholder='Contraseña' />

            <Button color='teal' fluid size='large' type="submit">
              Login
            </Button>

            <MDBBtn 
              onClick={() => { this.loginWithRedirect() }} 
              style={{marginTop: 20, letterSpacing: 1, color: "white", borderColor: "white", width: 300}} color="white">
              ACCEDER
            </MDBBtn>

            { countIntentos != 0 ? 
              <Message negative>
                <Message.Header>Clave incorrecta</Message.Header>
                <p>No se ha podido iniciar sessión, verifique sus credenciales</p>
              </Message>
            : 
             ''}            
          </Segment>
        </Form>
      
      </Grid.Column>
    </Grid>

  )
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
}*/